import { styled, Typography } from 'shared/Houston';

export const Container = styled.div`
  text-align: center;
`;
export const Title = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing.inline.xxxs};
`;
